
export const getBaseURL = () => {
  if (typeof window !== "undefined") {
    const currentDomain = window.location.hostname;

    const domainToURLMap = {
      "localhost": process.env.NEXT_PUBLIC_CONECAO_URL_LOCA_adminL,
      "futuriss2.futurissvision.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_FUTURISSVISION_ADMIN,
      "www.futuriss2.futurissvision.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_FUTURISSVISION_ADMIN,

      "istaangola.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISTA,
      "www.istaangola.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISTA,

      "siguc.ispozls.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISPOZANGOLS_ADMIN,
      "www.siguc.ispozls.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISPOZANGOLS_ADMIN,

      "testesangola.futurissvision.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_FUTURISSTESTS_ADMIN,
      "www.testesangola.futurissvision.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_FUTURISSTESTS_ADMIN,

      "ucansoft.net": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_UCAN,
      "www.ucansoft.net": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_UCAN,

      "futuriss.unikinrdc.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_UNIKINRDC_ADMIN,
      "www.futuriss.unikinrdc.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_UNIKINRDC_ADMIN,

      "futuriss.lecartesienrdc.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_LECARTESIEN,
      "www.futuriss.lecartesienrdc.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_LECARTESIEN,

      "futuriss.petitslutinsapp.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_PETTISLUTINS_ADMIN,
      "www.futuriss.petitslutinsapp.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_PETTISLUTINS_ADMIN,

      "futuriss.ideroapp.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_IDERO_ADMIN,
      "www.futuriss.ideroapp.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_IDERO_ADMIN,

      "cum.futurissvision.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_CUM_ADMIN,
      "www.cum.futurissvision.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_CUM_ADMIN,

      "futuriss.ispozangosede.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISPOZANGOSEDE_ADMIN,
      "www.futuriss.ispozangosede.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_ISPOZANGOSEDE_ADMIN,

      "futuriss.sieraschools.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_SIERASCHOOL_ADMIN,
      "www.futuriss.sieraschools.com": process.env.NEXT_PUBLIC_CONECAO_URL_ONLINE_SIERASCHOOL_ADMIN,

      "ease.futurissvision.com": process.env.NEXT_PUBLIC_CONECAO_URL_LOCA_adminL
    };

    return domainToURLMap[currentDomain] || process.env.NEXT_PUBLIC_CONECAO_URL_LOCA_adminL ;
  }

  return process.env.NEXT_PUBLIC_CONECAO_URL_LOCA_adminL; // Default fallback
};
